// fetch class lesson
export const START_FETCH_CLASS_LESSON = 'START_FETCH_CLASS_LESSON'
export const SUCCESS_FETCH_CLASS_LESSON = 'SUCCESS_FETCH_CLASS_LESSON'
export const FAILED_FETCH_CLASS_LESSON = 'FAILED_FETCH_CLASS_LESSON'

import getClassLesson from 'controllers/class/getClassLesson'

export function fetchClassLesson(classId, params){
  return function(dispatch) {
    dispatch({
      type: START_FETCH_CLASS_LESSON,
      payload: {
        fetching: true
      }
    })

    getClassLesson(classId, params)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_CLASS_LESSON,
        payload: {...result, fetching: false}
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_CLASS_LESSON,
        payload: err
      })
    })
  }
}

const initState = {
  detail: {}
}

export default function classLessonDetail(state = initState, action){
  switch(action.type){
    case START_FETCH_CLASS_LESSON: {
      // IMPORTANT NOTE: 
      // When start fetching class lesson it's requred to empty out detail 
      return {...state, ...action.payload, detail: null, }
    }
    case SUCCESS_FETCH_CLASS_LESSON: {
      return {...state, detail: action.payload, fetching: action.payload.fetching}
    }
    case FAILED_FETCH_CLASS_LESSON: {
      return state
    }
    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/ducks.js